import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, OperationType, ROUTE_PATH } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { InternshipListModel, InternshipListChartsModel } from 'common/models/page-models/internship/internship-list/form-model/internship-list-form-data.model';
import { cardStatsMetaModel } from 'common/models/page-models/internship/internship-list/form-model/internship-list-form-meta-model';
import { InternshipListListingModel, InternshipListGridPostParams } from 'common/models/page-models/internship/internship-list/grid-model/internship-list-grid-model';
import { InternshipStudentListModel } from 'common/models/page-models/internship/internship-student-list/internship-student-list.data';
import { InternshipStudentListListingModel } from 'common/models/page-models/internship/internship-student-list/internship-student-grid.data';
import { InternshipStudentListGridParams } from 'common/models/page-models/internship/internship-student-list/internship-student-list.meta.model';


@Injectable({
    providedIn: 'root'
})
export class InternshipStudentListDataService extends GridDataService<InternshipStudentListListingModel, InternshipStudentListModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.studentListData, http, ss);
    }

    createInstance(): InternshipStudentListListingModel {
        return new InternshipStudentListListingModel();
    }

    override getGridParams(param): GridPostParams {
        return new InternshipStudentListGridParams();
    }

    getDeleteUrl() {
        return '';
    }
}